export enum PromptType {
  NewJourney = 'journey',
  NewTileset = 'tiles',
}

export const PROMPT_MAX_CHAR_COUNT = 400;
export const PROMPT_FIELD = 'prompt';

export const PROMPT_DEFAULT = '';

export const FIRST_LINE_BULLET = '• ';
export const BULLET = `\n${FIRST_LINE_BULLET}`;

const getBulletString = (bullets: string[]) => bullets.map((b) => `${BULLET}${b}`).join('');

export const PROMPT_TEXT = {
  [PromptType.NewJourney]: {
    placeholder: 'Describe the journey you want to create, or select a starter below.',
  },
  [PromptType.NewTileset]: {
    placeholder: 'Describe the tiles you want to create.',
  },
};

export const PROMPT_PRESETS = [
  {
    buttonText: 'Welcome journey',
    value: `Create a welcome journey that${getBulletString([
      'Starts with an event',
      'Sends a sign-up confirmation email',
      'Checks to see if the user has completed their account setup (and reminds them to if they haven’t)',
      'Sends a discount or special offer after users complete their account setup',
      'Adds users to subscriber lists that are relevant to them',
    ])}`,
  },
  {
    buttonText: 'Abandoned cart journey',
    value: `Create an abandoned cart journey that${getBulletString([
      'Starts with an event',
      'Waits 1 hour',
      'If the user hasn’t made a purchase, sends an email about the item in the user’s cart',
    ])}`,
  },
  {
    buttonText: 'Win-back journey',
    value: `Create a win-back journey that${getBulletString([
      'Runs weekly, adding new users from a list schedule',
      'Sends a message on the user’s preferred channel',
      'Waits 1 week to see if the user has logged in, and sends a discount or special offer if they do',
      'Sends all others 5 reminder messages over 5 weeks on their preferred channels',
    ])}`,
  },
];

export const PROMPT_HELPERS = [
  {
    buttonText: 'Starts when',
    value: 'Triggered via API',
    onlyShowInNewJourneys: true,
  },
  {
    buttonText: 'Send message',
    value: 'Send an email',
  },
  {
    buttonText: 'Delay',
    value: 'Delay 1 day',
  },
  {
    buttonText: 'Split users',
    value: 'Split users by whether or not they are subscribed',
  },
];

export const ERROR_MESSAGES = {
  EMPTY_PROMPT: 'Whoops... we need some details before we can generate tiles for you.',
  NO_RESULTS: 'Whoops! Having trouble with this one. Try modifying your input.',
  DEFAULT: 'Hmm... something went wrong. Please try again later.',
};

export enum ToggleType {
  Add = 'add',
  Replace = 'replace',
}

export const TOGGLE_OPTIONS = [
  { name: 'Replace selected tiles', value: ToggleType.Replace },
  { name: 'Add tiles to path', value: ToggleType.Add },
];
